export default __webpack_public_path__ + "static/project-slide-3-415-700-56dac344f3be640085bbd2c09cb48228.webp";